export default "__VITE_ASSET__70f2f541__"